import { render, staticRenderFns } from "./TimelineData.vue?vue&type=template&id=d22a64d2&scoped=true&"
import script from "./TimelineData.vue?vue&type=script&lang=js&"
export * from "./TimelineData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22a64d2",
  null
  
)

export default component.exports